import React from 'react';
import './index.less';

export interface TextureProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange' | 'color'> {
    prefixCls?: string;
    width?: number;
    textureContent?: React.ReactNode;
}

const Texture = React.forwardRef<HTMLDivElement, TextureProps>((props, ref) => {
    const { prefixCls = 'c-color-texture', className, width = 280, style, textureContent, ...other } = props;

    return (
        <div
            {...other}
            className={`${prefixCls} ${className || ''}`}
            ref={ref}
            style={{
                width,
                ...style,
            }}
        >
            {textureContent}
        </div>
    );
});

Texture.displayName = 'Texture';

export default React.memo(Texture);
